<template>
  <div class="home-container">
    <header class="header">
      <div class="container header-inner">
        <div class="logo-area">
          <span class="logo-icon">⚙️</span>
          <span class="logo-text">华魏WMS</span>
        </div>
        <div class="nav-menu">
          <a href="#" @click.prevent="scrollToSection('home')">首页</a>
          <a href="#" @click.prevent="scrollToSection('features')">产品功能</a>
          <a href="#" @click.prevent="scrollToSection('solutions')">解决方案</a>
          <a href="#" @click.prevent="scrollToSection('cases')">客户案例</a>
          <a href="#" @click.prevent="scrollToSection('help')">帮助中心</a>
        </div>
        <div class="header-btns">
          <el-button class="btn-outline" @click="goToLogin">登录</el-button>
          <el-button class="btn-primary" @click="applyTrial">免费试用</el-button>
        </div>
      </div>
    </header>

    <main>
      <!-- Banner 区 -->
      <section class="banner">
        <div class="container">
          <h1>华魏WMS —— 制造业仓储智能管理平台</h1>
          <p>序列号级追溯 · 三现收货防伪 · 维纳斯件版本化管理 · 与ERP/MES无缝协同</p>
          <div class="banner-buttons">
            <el-button class="btn-primary btn-large" @click="applyTrial">免费试用</el-button>
            <el-button class="btn-outline btn-large" @click="contactSales">联系销售</el-button>
          </div>
        </div>
      </section>

      <!-- 核心优势 -->
      <section class="advantages">
        <div class="container">
          <h2 class="section-title">为什么选择华魏WMS</h2>
          <div class="grid-4">
            <div class="advantage-card">
              <div class="advantage-icon">🔒</div>
              <h3>安全可靠</h3>
              <p>乐观锁防并发超卖，库存流水只增不删，负库存物理阻断，银行级风控。</p>
            </div>
            <div class="advantage-card">
              <div class="advantage-icon">📱</div>
              <h3>降本增效</h3>
              <p>微信小程序替代工业PDA，员工自带手机，硬件成本直降90%。</p>
            </div>
            <div class="advantage-card">
              <div class="advantage-icon">⚡</div>
              <h3>简易部署</h3>
              <p>SaaS模式，云端开通即用，支持私有化，30分钟完成配置。</p>
            </div>
            <div class="advantage-card">
              <div class="advantage-icon">🔄</div>
              <h3>工位协同</h3>
              <p>与工位MES原生打通，完工自动入库，领料自动扣减，业财一体。</p>
            </div>
          </div>
        </div>
      </section>

      <!-- 产品功能亮点 -->
      <section class="features">
        <div class="container">
          <h2 class="section-title">核心功能覆盖全仓储场景</h2>
          <div class="features-grid">
            <div class="feature-item">
              <div class="feature-icon">📍</div>
              <h4>货位管理</h4>
              <p>多级货位，支持扫码快速定位，库存实时可视。</p>
            </div>
            <div class="feature-item">
              <div class="feature-icon">📸</div>
              <h4>三现收货</h4>
              <p>强制拍照+GPS/WiFi强度+时间水印，杜绝伪造入库。</p>
            </div>

          </div>
        </div>
      </section>

      <!-- 最新动态 / 客户案例 -->
      <section class="news">
        <div class="container">
          <h2 class="section-title">最新动态 & 客户案例</h2>
          <div class="news-list">
            <div class="news-item">
              <div class="news-date">2026-04-28</div>
              <div class="news-title">
                <a href="#" @click.prevent="showCaseDetail('华魏WMS获国家发明专利受理（申请号202610630008.9）')">华魏WMS获国家发明专利受理（申请号202610630008.9）</a>
              </div>
            </div>
            <div class="news-item">
              <div class="news-date">2026-06-03</div>
              <div class="news-title">
                <a href="#" @click.prevent="showCaseDetail('湘潭弘峰机器人即将引入华魏WMS')">湘潭弘峰机器人即将引入华魏WMS</a>
              </div>
            </div>
            <div class="news-item">
              <div class="news-date">2026-7月</div>
              <div class="news-title">
                <a href="#" @click.prevent="showCaseDetail('工位MES+WMS一体化方案将于计划于26年7月发布，助力制造企业数字化转型')">工位MES+WMS一体化方案将于计划于26年7月发布，助力制造企业数字化转型</a>
              </div>
            </div>
                        <div class="news-item">
              <div class="news-date">2026-8月</div>
              <div class="news-title">
                <a href="#" @click.prevent="showCaseDetail('“维纳斯件”版本化管理模块即将上线，赋能再制造过程，敬请期待')">“维纳斯件”版本化管理模块即将上线，赋能再制造过程，敬请期待</a>
              </div>
            </div>
          </div>
        </div>
      </section>
    </main>

    <footer class="footer">
      <div class="container">
        <div class="footer-inner">
          <div>
            <div style="font-size: 20px; font-weight: 600; margin-bottom: 12px;">湖南华魏智能装备有限公司</div>
            <div style="font-size: 14px;">赋能制造业·可信赖的仓储数字底座</div>
          </div>
          <div class="footer-links">
            <div>
              <a href="#" @click.prevent="aboutUs">关于我们</a><br><br>
              <a href="#" @click.prevent="contactUs">联系方式</a>
            </div>
            <div>
              <a href="#" @click.prevent="privacyPolicy">隐私政策</a><br><br>
              <a href="#" @click.prevent="userAgreement">用户协议</a>
            </div>
            <div>
              <span>📞 13203212923</span><br><br>
              <span>✉️ quecanran@qq.com</span>
            </div>
          </div>
        </div>
        <div class="copyright">
          © 2026 湖南华魏智能装备有限公司  |  备案号：湘ICP备2026014631号-2
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'Home',
  methods: {
    goToLogin() {
      this.$router.push('/login')
    },
    applyTrial() {
      this.$message.info('免费试用申请通道即将开放，敬请期待。')
    },
    contactSales() {
      this.$message.info('商务咨询：quecanran@qq.com')
    },
    scrollToSection(sectionId) {
      const el = document.getElementById(sectionId)
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    showCaseDetail(title) {
      this.$message.info(`了解更多：${title}`)
    },
    aboutUs() {
      this.$message.info('湖南华魏智能装备有限公司，专注制造业、农牧业的数字化、智能化。')
    },
    contactUs() {
      this.$message.info('邮箱：quecanran@qq.com | 电话：13203212923')
    },
    privacyPolicy() {
      this.$message.info('隐私政策内容即将公布。')
    },
    userAgreement() {
      this.$message.info('用户协议内容即将公布。')
    }
  }
}
</script>

<style scoped>
/* 将原CSS复制过来，并确保作用域仅限此组件 */
.home-container {
  font-family: 'Segoe UI', 'PingFang SC', Roboto, 'Helvetica Neue', sans-serif;
  background-color: #fff;
  color: #1f2d3d;
  line-height: 1.5;
}
.container {
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 24px;
}
.header {
  background: #fff;
  box-shadow: 0 1px 12px rgba(0, 0, 0, 0.05);
  position: sticky;
  top: 0;
  z-index: 100;
}
.header-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 70px;
  flex-wrap: wrap;
}
.logo-area {
  display: flex;
  align-items: center;
  gap: 8px;
}
.logo-icon {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(135deg, #1E88E5, #0b5e9e);
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
}
.logo-text {
  font-size: 22px;
  font-weight: 600;
  color: #1E88E5;
}
.nav-menu {
  display: flex;
  gap: 32px;
  align-items: center;
}
.nav-menu a {
  text-decoration: none;
  color: #2c3e50;
  font-weight: 500;
  transition: color 0.2s;
  cursor: pointer;
}
.nav-menu a:hover {
  color: #1E88E5;
}
.header-btns {
  display: flex;
  gap: 16px;
}
.btn-outline {
  background: transparent;
  border: 1px solid #1E88E5;
  padding: 6px 18px;
  border-radius: 30px;
  color: #1E88E5;
  cursor: pointer;
  transition: 0.2s;
  font-weight: 500;
}
.btn-outline:hover {
  background: #e9f3fc;
}
.btn-primary {
  background: #1E88E5;
  border: none;
  padding: 6px 22px;
  border-radius: 30px;
  color: white;
  cursor: pointer;
  font-weight: 500;
  transition: 0.2s;
}
.btn-primary:hover {
  background: #0b5e9e;
}
.banner {
  background: linear-gradient(105deg, #f0f7ff 0%, #e3f0fc 100%);
  padding: 80px 0;
  text-align: center;
}
.banner h1 {
  font-size: 42px;
  font-weight: 700;
  color: #0f2b3d;
  margin-bottom: 16px;
}
.banner p {
  font-size: 18px;
  color: #3a546d;
  max-width: 700px;
  margin: 0 auto 32px;
}
.banner-buttons {
  display: flex;
  gap: 20px;
  justify-content: center;
}
.btn-large {
  padding: 12px 32px;
  font-size: 16px;
}
.advantages {
  padding: 70px 0;
  background: #fff;
}
.section-title {
  text-align: center;
  font-size: 32px;
  font-weight: 600;
  margin-bottom: 48px;
  color: #1e4663;
}
.grid-4 {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 32px;
}
.advantage-card {
  text-align: center;
  padding: 24px 16px;
  background: #f8fafc;
  border-radius: 24px;
  transition: transform 0.2s;
}
.advantage-card:hover {
  transform: translateY(-4px);
  box-shadow: 0 10px 20px rgba(0,0,0,0.05);
}
.advantage-icon {
  font-size: 48px;
  margin-bottom: 16px;
}
.advantage-card h3 {
  font-size: 22px;
  margin-bottom: 10px;
  color: #1E88E5;
}
.advantage-card p {
  color: #4a627a;
}
.features {
  background: #f9fbfd;
  padding: 70px 0;
}
.features-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 28px;
}
.feature-item {
  background: white;
  border-radius: 20px;
  padding: 30px 20px;
  text-align: center;
  box-shadow: 0 4px 12px rgba(0,0,0,0.03);
  border: 1px solid #eef2f6;
  transition: all 0.2s;
}
.feature-item:hover {
  border-color: #cde3f5;
  box-shadow: 0 12px 24px rgba(0,0,0,0.05);
}
.feature-icon {
  font-size: 42px;
  margin-bottom: 18px;
}
.feature-item h4 {
  font-size: 20px;
  margin-bottom: 10px;
  color: #1e4663;
}
.feature-item p {
  color: #5d6f83;
  font-size: 14px;
}
.news {
  padding: 70px 0;
  background: #fff;
}
.news-list {
  max-width: 800px;
  margin: 0 auto;
}
.news-item {
  display: flex;
  align-items: baseline;
  padding: 18px 0;
  border-bottom: 1px solid #ecf3f9;
}
.news-date {
  width: 100px;
  color: #1E88E5;
  font-weight: 500;
}
.news-title {
  flex: 1;
  font-weight: 500;
}
.news-title a {
  text-decoration: none;
  color: #2c3e50;
  cursor: pointer;
}
.news-title a:hover {
  color: #1E88E5;
}
.footer {
  background: #0a2540;
  color: #cbdde9;
  padding: 48px 0 24px;
}
.footer-inner {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 32px;
}
.footer-links {
  display: flex;
  gap: 48px;
  flex-wrap: wrap;
}
.footer-links a {
  color: #cbdde9;
  text-decoration: none;
  cursor: pointer;
}
.footer-links a:hover {
  color: white;
}
.copyright {
  text-align: center;
  margin-top: 48px;
  padding-top: 24px;
  border-top: 1px solid #1e3a5f;
  font-size: 14px;
}
@media (max-width: 900px) {
  .header-inner {
    flex-direction: column;
    height: auto;
    padding: 12px 0;
    gap: 12px;
  }
  .nav-menu {
    gap: 20px;
    flex-wrap: wrap;
    justify-content: center;
  }
  .banner h1 {
    font-size: 32px;
  }
  .grid-4 {
    gap: 20px;
  }
}
@media (max-width: 640px) {
  .banner-buttons {
    flex-direction: column;
    align-items: center;
  }
  .news-item {
    flex-direction: column;
    gap: 6px;
  }
  .news-date {
    width: auto;
  }
}
</style>